import React, { useState, useEffect } from 'react';
import {
	Button,
	Upload,
	Typography,
	Steps,
	Checkbox,
	Modal,
	Badge,
	Popover,
	DatePicker
} from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, PlusCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { refreshData } from '../../../store/auth/actions';
import { trace } from '../../../components/tagmanager';
import { useParams, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
const trash = require('../../../assets/icons/trash.png');
const moreMenu = require('../../../assets/icons/moreMenu.png');
import { commonNotifications } from 'mortgage-documents/src/document-boxes/CommonItems';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('en');
dayjs.locale('vi');

const { Text } = Typography;
const { Step } = Steps;

const FormalizationDesktop = ({ dataMortgage, userMortgageId, stages }) => {
	const [valuesData, setValuesData] = useState([]);
	const { t } = useTranslation();
	const userToken = useSelector((state) => state.auth.token);
	const [saveFileDataField, setSaveFileDataField] = useState(null);
	const [typeFile, setTypeFile] = useState();
	const [fein, setfein] = useState(false);
	const [finishStep, setFinishStep] = useState(false);
	const navigate = useNavigate();
	const [, setEwallet] = useState(0);
	const [checkBoxData, setCheckBoxData] = useState(
		dataMortgage !== undefined &&
			dataMortgage.mortgage &&
			dataMortgage.mortgage.signedDocumentation === true
			? true
			: false
	);
	const [mortgageData, setMortgageData] = useState();
	const [idFileFein, setIdFileFein] = useState();
	const [, setDataClient] = useState('');
	const operations = useSelector((state) => state.auth.operations);
	const { operationId } = useParams();
	const nameOperations =
		operations !== undefined &&
		operations.find((operation) => operation.mortgageId === operationId);
	const rol = useSelector((state) => state.auth.roles);
	const location = useLocation();
	const [feinSigned, setFeinSigned] = useState(undefined);
	let countFormalization = 0;
	const [bankOffer, setBankOffer] = useState(undefined);
	const [feinId, setFeinId] = useState(undefined);
	const [activePopover, setActivePopover] = useState(null);
	const [showModalFinish, setShowModalFinish] = useState(false);

	useEffect(() => {
		getEwallet();
		//setIsClientPay(dataMortgage.mortgage !== undefined ? dataMortgage.mortgage.appraisalPaid : false)
		dataValueInfoUpload();
		getMortgageData();
		getTokenPay();
		getBankOffer();

		if (stages === 'formalization') {
			trace({
				location,
				userToken,
				rol,
				stage: 'formalization',
				operationName: nameOperations && nameOperations.name
				//extra: operationsData
			});
		}
	}, []);

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: userMortgageId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const getEwallet = () => {
		axios
			.get(`${env.api.url}/v1/user/refundable-deposit`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setEwallet(response.data.data.amount);
			});
	};

	const dataValueInfoUpload = () => {
		axios
			.get(`${env.api.url}/v1/documents/get-operation-documents/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setValuesData(response.data.data);

				setfein(response.data.data.some((value) => value.type === 'fein'));
				const fein = response.data.data.find((value) => value.type === 'fein');
				setFeinId(fein.id);

				if (response.data.data) {
					response.data.data.map((data) => {
						if (data.type === 'fein' && data.owner === null) {
							setIdFileFein(data.id);
						}
					});
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleUploadFile = (file) => {
		axios
			.put(
				`${env.api.url}/api/mortgages/attachment`,
				{
					mortgageId: userMortgageId,
					file: file[1].file,
					fileName: file[1].fileName,
					type: typeFile,
					owner: 'owner1'
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				commonNotifications('success', t('document.success'), t('document.analyst'), true);
				dataValueInfoUpload();
			})
			.catch((error) => {
				commonNotifications('error', t('document.waitUploadError'), t('document.error'), true);
				console.log(error);
			});
	};

	const handleClickPlus = (typeFile) => {
		setTypeFile(typeFile);
		/*if (typeFile === "signedFein") {
      saveData("mortgage", "signedDocumentation", true);
    }*/
	};

	const saveFileData = (file, name) => {
		const documentFile = [saveFileDataField];
		documentFile.push({
			file,
			fileName: name
		});
		setSaveFileDataField(documentFile);
		handleUploadFile(documentFile);
	};

	const uploadProps = {
		beforeUpload: (file) => {
			return new Promise(() => {
				const reader = new FileReader();
				reader.readAsDataURL(file);

				if (file.size < 50000000) {
					reader.onload = () => {
						const base64File = reader.result.split(',')[1];
						saveFileData(base64File, file.name);
					};
				} else {
					commonNotifications(
						'error',
						t('document.waitUploadError'),
						t('documentation.tooHeavy'),
						true
					);
				}
			});
		}
	};

	const handleFileDownload = (documentId) => {
		axios
			.get(`${env.api.url}/v1/documents/get-document-url/${documentId}?token=${userToken}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					window.open(response.data.data.url, '_blank'); //to open new page
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const saveData = (participant, key, value) => {
		if (key === 'signed' && mortgageData.signed === true) {
			return;
		}
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${userMortgageId}`,
				{ key, participant, value },
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				if (response.data.success) {
					getMortgageData();
					refreshData();
					setCheckBoxData(response.data.data.mortgage.signedDocumentation);
				}
			});

		if (key === 'signed' && value) {
			setShowModalFinish(true);
		}
		if (key === 'signedDocumentation' && value === true) {
			setFinishStep(true);
		}
	};

	const getMortgageData = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/data/get/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				const { mortgage } = response.data.data;
				setMortgageData(mortgage);

				const isFeinSigned =
					!_.isNil(_.get(mortgage, 'signedDocumentation')) &&
					_.get(mortgage, 'signedDocumentation') !== false;
				setFeinSigned(isFeinSigned);
			});
	};

	const deleteDocument = (documentId) => {
		axios
			.get(`${env.api.url}/v1/documents/delete-document/${documentId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(() => {
				dataValueInfoUpload();
				setExistAppraisal(false);
				countFormalization = countFormalization - 1;
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const selectWidget = (documentId) => {
		return (
			<div>
				<div
					onClick={() => handleFileDownload(documentId)}
					style={{
						display: 'flex',
						border: 'none',
						padding: 5,
						cursor: 'pointer'
					}}>
					<DownloadOutlined className="see-document" style={{ marginTop: 3 }} />
					<Text className="see-document see-document-text" style={{ marginLeft: 4 }}>
						{t('init.download')}
					</Text>
				</div>
				<div
					onClick={() => modalDelete(documentId)}
					style={{
						display: 'flex',
						border: 'none',
						padding: 5,
						cursor: 'pointer',
						alignItems: 'center'
					}}>
					<img src={trash} alt="trash" width={17} height={'auto'} style={{ marginLeft: -2 }} />
					<Text className="delete-document delete-document-text" style={{ marginLeft: 4 }}>
						{t('loan.delete')}
					</Text>
				</div>
			</div>
		);
	};

	const getBankOffer = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/selected-bank-offer/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setBankOffer(response.data.data.bank.id);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleOk = () => {
		setShowModalFinish(false);
		navigate(`/my-financial-profile/credits/form/${bankOffer}`);
	};

	const modalDelete = (documentId) => {
		Modal.confirm({
			className: 'engel-modal-delete',
			okButtonProps: {
				className: 'button-primari-delete-gibobs',
				style: {
					width: '45%',
					height: 40
				}
			},
			cancelButtonProps: {
				className: 'button-secundary-gibobs',
				style: { width: '45%', height: 40 }
			},
			okText: <Text style={{ color: 'white' }}>{t('docs.deleteButtonNew')}</Text>,
			cancelText: <Text>{t('offers.cancel')}</Text>,
			title: <Text>{t('docs.deleteDocNew')}</Text>,
			icon: null,
			content: <Text>{t('docs.deleteDocTextNew')}</Text>,
			onOk() {
				deleteDocument(documentId);
			}
		});
	};

	const ownerList = [];
	if (dataMortgage && dataMortgage.mortgage) {
		for (let i = 1; i <= Number(dataMortgage.mortgage.participants); i++) {
			ownerList.push(`owner${i}`);
		}
		for (let i = 0; i < Number(dataMortgage.mortgage.guarantors); i++) {
			ownerList.push(`guarantor${i + 1}`);
		}
	}

	return (
		<div>
			{stages === 'formalization' && mortgageData && (
				<div>
					{mortgageData && (
						<div style={{ marginTop: 10, padding: '16px 16px 16px 0' }}>
							<Steps
								direction="vertical"
								size="small"
								status="error"
								current={mortgageData && feinSigned ? 1 : 0}
								className="StepsMobileAppraisal">
								<Step
									style={{ color: '#b3b3b3' }}
									title={
										<div style={{ marginTop: 4 }}>
											<Text strong style={{ fontSize: '14px' }}>
												{t('formalization.condictions')}
											</Text>
										</div>
									}
									description={
										<div>
											{/* No existe documento de fein */}
											{!feinSigned && !fein && (
												<Text style={{ fontSize: 14, fontWeight: 400, color: '#666666' }}>
													{t('formalization.documents')}
												</Text>
											)}
											{/* No hay fein pero sí hay link digital */}
											{mortgageData?.digitalContractLink &&
												checkBoxData === false &&
												!feinSigned &&
												!fein && (
													<div
														style={{
															marginTop: 16,
															display: 'flex',
															flexDirection: 'column',
															gap: 2
														}}>
														<Text style={{ fontSize: 14, fontWeight: 600, color: '#666666' }}>
															{t('formalization.pdf')}:{' '}
															<a
																style={{
																	fontWeight: 400,
																	color: '#666666',
																	textDecoration: 'underline'
																}}
																target={'_blank'}
																href="/guiaLiberbank.pdf">
																{t('formalization.signature')}
															</a>
														</Text>
														<Text style={{ fontSize: 14, fontWeight: 600, color: '#666666' }}>
															{t('formalization.link')}:{' '}
															<a
																style={{
																	fontWeight: 400,
																	color: '#666666',
																	textDecoration: 'underline'
																}}
																target={'_blank'}
																href={`${
																	mortgageData.digitalContractLink !== undefined
																		? mortgageData.digitalContractLink
																		: ''
																}`}>
																{mortgageData.digitalContractLink !== undefined
																	? mortgageData.digitalContractLink
																	: ''}
															</a>
														</Text>
														<div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
															{ownerList &&
																ownerList.map((owner) => {
																	return (
																		dataMortgage[owner]?.userBankCode && (
																			<Text
																				key={owner}
																				style={{
																					fontSize: 12,
																					fontWeight: 600,
																					color: '#666666'
																				}}>
																				{t(`form.${owner}`)}:{' '}
																				<span style={{ fontWeight: 400 }}>
																					{dataMortgage[owner]?.userBankCode}
																				</span>
																			</Text>
																		)
																	);
																})}
														</div>
													</div>
												)}
											{/* Hay documento de fein sin firmar y existe link digital */}
											{/* {!feinSigned && mortgageData?.digitalContractLink && fein && ( */}
											{!feinSigned && fein && (
												<Text style={{ fontSize: 14, fontWeight: 400, color: '#666666' }}>
													{t('formalization.filesAvailables')}
												</Text>
											)}
											{/* Hay fein pero no está firmada*/}
											{fein && !finishStep && !feinSigned && (
												<div style={{ marginTop: 16 }}>
													<div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
														<Text style={{ fontWeight: 600, color: '#666666' }}>
															{t('formalization.pdf')}:{' '}
															<a
																style={{
																	fontWeight: 400,
																	color: '#666666',
																	textDecoration: 'underline'
																}}
																target={'_blank'}
																href="/guia/guia.pdf">
																{t('formalization.signature')}
															</a>
														</Text>
														<Text style={{ fontWeight: 600, color: '#666666' }}>
															{t('formalization.pdf')}:{' '}
															<a
																style={{
																	fontWeight: 400,
																	color: '#666666',
																	textDecoration: 'underline'
																}}
																onClick={() => {
																	handleFileDownload(feinId);
																}}>
																{t('__sabadell-es__docs.fein')}
															</a>
														</Text>
													</div>
													<div style={{ display: 'flex', gap: 8 }}>
														{valuesData &&
															valuesData.map((data) => {
																if (data.type === 'signedFein' && data.owner !== null) {
																	countFormalization = countFormalization + 1;
																	return (
																		<div style={{ marginTop: 12 }}>
																			<div
																				style={{
																					fontSize: 10,
																					fontWeight: 400,
																					color: '#808080'
																				}}>
																				<Button
																					className="gibobs-document-button"
																					style={{
																						width: 178,
																						height: 60,
																						backgroundColor: 'white',
																						borderRadius: '4px',
																						borderColor: '#477306',
																						display: 'flex',
																						alignItems: 'center',
																						justifyContent: 'space-between'
																					}}>
																					<Text
																						style={{
																							color: '#666666',
																							fontSize: 12,
																							fontWeight: 400
																						}}>
																						<CheckOutlined
																							style={{
																								color: '#477306',
																								marginRight: 4
																							}}
																						/>
																						FEIN{countFormalization}.pdf
																					</Text>
																					<Popover
																						content={selectWidget(data.id)}
																						style={{ textAlign: 'center' }}
																						placement="bottom"
																						trigger="click"
																						open={activePopover === data.id}
																						onOpenChange={(open) => {
																							if (open) {
																								setActivePopover(data.id);
																							} else {
																								setActivePopover(null);
																							}
																						}}>
																						<img src={moreMenu} />
																					</Popover>
																				</Button>
																			</div>
																		</div>
																	);
																}
															})}
														{countFormalization !== 2 && (
															<Upload {...uploadProps}>
																<Button
																	onClick={() => handleClickPlus('signedFein')}
																	style={{
																		padding: '8px 16px',
																		backgroundColor: 'white',
																		borderRadius: '4px',
																		border: '1px solid #BE4B0A',
																		height: 60,
																		marginTop: valuesData ? 12 : 24
																	}}>
																	<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
																		<Badge
																			dot={true}
																			size="small"
																			className="gb-badget"
																			style={{ marginTop: 8 }}
																		/>
																		<Text>{t('formalization.attachSigned')}</Text>
																	</div>
																	<div
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			gap: 4,
																			marginTop: 8
																		}}>
																		<Text style={{ fontSize: 16, color: '#C80000' }}>{'+'}</Text>
																		<Text className="attach-document-text">
																			{t('file.newOnboardingDocs')}
																		</Text>
																	</div>
																</Button>
															</Upload>
														)}
													</div>
												</div>
											)}
											{(mortgageData.digitalContractLink || fein) && !feinSigned && (
												<Checkbox
													style={{ marginTop: 16, color: '#666666' }}
													onChange={() => saveData('mortgage', 'signedDocumentation', true)}>
													{t('formalization.signatureFilesApp')}
												</Checkbox>
											)}
										</div>
									}
								/>
								<Step
									title={
										<Text
											style={{
												fontSize: 14,
												fontWeight: 600,
												color: feinSigned ? '#262626' : '#E5E5E5'
											}}>
											{t('formalization.finish')}
										</Text>
									}
									description={
										(mortgageData && feinSigned) || finishStep ? (
											<div style={{ lineHeight: '16px' }}>
												<Text
													style={{
														fontSize: 14,
														fontWeight: 400,
														color: '#666666'
													}}>
													{t('formalization.date')}
												</Text>
												<div style={{ marginTop: 16, display: 'flex', flexDirection: 'column' }}>
													<Text
														style={{
															fontSize: 14,
															color: '#666666',
															fontWeight: 400
														}}>
														{t('formalization.dateEstimated')}
													</Text>
													<div style={{ display: 'flex', alignItems: 'flex-end', gap: 40 }}>
														{mortgageData !== undefined && (
															<DatePicker
																defaultValue={
																	mortgageData &&
																	mortgageData?.mortgage?.estimatedSignDate !== 'Invalid Date' &&
																	!_.isNil(mortgageData?.mortgage?.estimatedSignDate)
																		? dayjs(mortgageData.mortgage.estimatedSignDate)
																		: undefined
																}
																style={{
																	height: '32px',
																	borderRadius: '4px',
																	borderColor: '#808080',
																	fontSize: '12px',
																	marginTop: '8px',
																	maxWidth: 200,
																	boxShadow: 'none'
																}}
																onChange={(e) => {
																	if (e) {
																		saveData(
																			'mortgage',
																			'estimatedSignDate',
																			e.format('YYYY-MM-DD')
																		);
																	}
																}}
																format="DD/MM/YYYY"
																allowClear={false}
																placeholder={'00/00/0000'}
																suffixIcon={<img src="/images/documents/calendar.svg" />}
															/>
														)}

														{(mortgageData && mortgageData && feinSigned) || finishStep ? (
															<Checkbox
																disabled={!mortgageData.estimatedSignDate ? true : false}
																checked={mortgageData.signed}
																onChange={() => saveData('mortgage', 'signed', true)}>
																<Text style={{ fontSize: 14, fontWeight: 400, color: '#666666' }}>
																	{t('formalization.notary')}
																</Text>
															</Checkbox>
														) : null}
													</div>
												</div>
											</div>
										) : null
									}
								/>
							</Steps>
						</div>
					)}
				</div>
			)}

			<Modal
				open={showModalFinish}
				onCancel={() => setShowModalFinish(false)}
				className="ModalFinish"
				onOk={() => setShowModalFinish(false)}
				okButtonProps={{ className: 'button-primary-engel', style: { width: '100%' } }}
				cancelButtonProps={{ style: { display: 'none' } }}
				title={t('formalization.thanksEV')}>
				<Text style={{ color: '#808080' }}>{t('formalization.thanks3')}</Text>
			</Modal>
		</div>
	);
};

export default FormalizationDesktop;
